<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">参与潜水活动的目的</div>
		<case-form :schema="schemaPurpose" />

		<div class="fs4 fw7 lh125 mt6 mb2">您在那里潜水？</div>
		<case-form :schema="schemaLocation" />

		<div class="fs4 fw7 lh125 mt6 mb2">潜水活动类型</div>
		<case-form :schema="schemaType" />

		<div class="fs4 fw7 lh125 mt6 mb2">请提供您参与潜水活动的详情：</div>
		<j-accordion class="b1 bc7 mb2 r2" colorWhenClosed="bg5" colorWhenOpen="bg2">
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">少于 50 呎（< 15.5 米）</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaLessThan50ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion class="b1 bc7 mb2 r2" colorWhenClosed="bg5" colorWhenOpen="bg2">
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">50-75 呎（15.5 米至 23 米）</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schema50to75ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion class="b1 bc7 mb2 r2" colorWhenClosed="bg5" colorWhenOpen="bg2">
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">76-100 呎（23 米至 30.5 米）</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schema76to100ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion class="b1 bc7 mb2 r2" colorWhenClosed="bg5" colorWhenOpen="bg2">
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">101-120 呎（30.5 米至 36.5 米）</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schema101to120ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion class="b1 bc7 mb2 r2" colorWhenClosed="bg5" colorWhenOpen="bg2">
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">超过 120 呎（>36.5 米）</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaOver120ft" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: "您是否一名认可潜水员？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isCertifiedDiverCN`,
					props: {
						suggest: {
							typeIncludes: `isCertifiedDiverCN`
						},
						createOptions: {
							type: `isCertifiedDiverCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "证书级别",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diverCertLevelCN`,
					props: {
						suggest: {
							typeIncludes: `diverCertLevelCN`
						},
						createOptions: {
							type: `diverCertLevelCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否潜水组织的会员？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfDivingClubCN`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfDivingClubCN`
						},
						createOptions: {
							type: `isMemberOfDivingClubCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0memberOfDivingClubDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `memberOfDivingClubDetailsCN`
						},
						createOptions: {
							type: `memberOfDivingClubDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否单独潜水？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDiveAloneCN`,
					props: {
						suggest: {
							typeIncludes: `isDiveAloneCN`
						},
						createOptions: {
							type: `isDiveAloneCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diveAloneDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `diveAloneDetailsCN`
						},
						createOptions: {
							type: `diveAloneDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: "康乐",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingForRecreationCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingForRecreationCN`
						},
						createOptions: {
							type: `isDivingForRecreationCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "商业",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingForCommercialCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingForCommercialCN`
						},
						createOptions: {
							type: `isDivingForCommercialCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaType() {
			return [
				{
					label: "指导",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeInstructionCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeInstructionCN`
						},
						createOptions: {
							type: `isDivingTypeInstructionCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "建筑",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeConstructionCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeConstructionCN`
						},
						createOptions: {
							type: `isDivingTypeConstructionCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "拯救",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeSalvageCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeSalvageCN`
						},
						createOptions: {
							type: `isDivingTypeSalvageCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "沉船潜水",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeWreckDivingCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeWreckDivingCN`
						},
						createOptions: {
							type: `isDivingTypeWreckDivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "冰潜",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeIceDivingCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeIceDivingCN`
						},
						createOptions: {
							type: `isDivingTypeIceDivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "搜索",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeSearchWorkCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeSearchWorkCN`
						},
						createOptions: {
							type: `isDivingTypeSearchWorkCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "洞穴潜水",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeCaveDivingCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeCaveDivingCN`
						},
						createOptions: {
							type: `isDivingTypeCaveDivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "夜潜",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeNightDivingCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeNightDivingCN`
						},
						createOptions: {
							type: `isDivingTypeNightDivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "技术潜水",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeTechnicalDivingCN`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeTechnicalDivingCN`
						},
						createOptions: {
							type: `isDivingTypeTechnicalDivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "请提供详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0divingTypeDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `divingTypeDetailsCN`
						},
						createOptions: {
							type: `divingTypeDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaLocation() {
			return [
				{
					label: "内海",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDiveLocationInlandWatersCN`,
					props: {
						suggest: {
							typeIncludes: `isDiveLocationInlandWatersCN`
						},
						createOptions: {
							type: `isDiveLocationInlandWatersCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "海洋",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDiveLocationSeaOrOceanCN`,
					props: {
						suggest: {
							typeIncludes: `isDiveLocationSeaOrOceanCN`
						},
						createOptions: {
							type: `isDiveLocationSeaOrOceanCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaLessThan50ft() {
			return [
				{
					label: "过去 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesLessThan50ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesLessThan50ftInLastYearCN`
						},
						createOptions: {
							type: `numOfDivesLessThan50ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeLessThan50ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTimeLessThan50ftInLastYearCN`
						},
						createOptions: {
							type: `averageTimeLessThan50ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesLessThan50ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesLessThan50ftInNextYearCN`
						},
						createOptions: {
							type: `numOfDivesLessThan50ftInNextYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeLessThan50ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTimeLessThan50ftInNextYearCN`
						},
						createOptions: {
							type: `averageTimeLessThan50ftInNextYearCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schema50to75ft() {
			return [
				{
					label: "过去 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives50to75ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDives50to75ftInLastYearCN`
						},
						createOptions: {
							type: `numOfDives50to75ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime50to75ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTime50to75ftInLastYearCN`
						},
						createOptions: {
							type: `averageTime50to75ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives50to75ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDives50to75ftInNextYearCN`
						},
						createOptions: {
							type: `numOfDives50to75ftInNextYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime50to75ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTime50to75ftInNextYearCN`
						},
						createOptions: {
							type: `averageTime50to75ftInNextYearCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schema76to100ft() {
			return [
				{
					label: "过去 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives76to100ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDives76to100ftInLastYearCN`
						},
						createOptions: {
							type: `numOfDives76to100ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime76to100ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTime76to100ftInLastYearCN`
						},
						createOptions: {
							type: `averageTime76to100ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives76to100ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDives76to100ftInNextYearCN`
						},
						createOptions: {
							type: `numOfDives76to100ftInNextYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime76to100ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTime76to100ftInNextYearCN`
						},
						createOptions: {
							type: `averageTime76to100ftInNextYearCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schema101to120ft() {
			return [
				{
					label: "过去 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives101to120ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDives101to120ftInLastYearCN`
						},
						createOptions: {
							type: `numOfDives101to120ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime101to120ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTime101to120ftInLastYearCN`
						},
						createOptions: {
							type: `averageTime101to120ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives101to120ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDives101to120ftInNextYearCN`
						},
						createOptions: {
							type: `numOfDives101to120ftInNextYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime101to120ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTime101to120ftInNextYearCN`
						},
						createOptions: {
							type: `averageTime101to120ftInNextYearCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaOver120ft() {
			return [
				{
					label: "过去 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesOver120ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesOver120ftInLastYearCN`
						},
						createOptions: {
							type: `numOfDivesOver120ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeOver120ftInLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTimeOver120ftInLastYearCN`
						},
						createOptions: {
							type: `averageTimeOver120ftInLastYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月潜水次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesOver120ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesOver120ftInNextYearCN`
						},
						createOptions: {
							type: `numOfDivesOver120ftInNextYearCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来 12 个月平均时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeOver120ftInNextYearCN`,
					props: {
						suggest: {
							typeIncludes: `averageTimeOver120ftInNextYearCN`
						},
						createOptions: {
							type: `averageTimeOver120ftInNextYearCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
